import {
  GET_ORG_ACCOUNTS,
  GET_ORG_ACCOUNTS_SUCCESS,
  GET_ORG_ACCOUNTS_FAILURE,
  GET_ORG_USERS_SUCCESS,
  GET_ORG_SUCCESS,
  UPDATE_ORG_ACCOUNT,
  UPDATE_ORG_ACCOUNT_SUCCESS,
  UPDATE_ORG_ACCOUNT_FAILURE,
  ADD_ORG_ACCOUNT,
  ADD_ORG_ACCOUNT_SUCCESS,
  ADD_ORG_ACCOUNT_FAILURE,
  DELETE_ORG_ACCOUNT,
  DELETE_ORG_ACCOUNT_SUCCESS,
  DELETE_ORG_ACCOUNT_FAILURE,
  DELETE_ORG_USER,
  DELETE_ORG_USER_SUCCESS,
  DELETE_ORG_USER_FAILURE,
  CLEAR_ALL_MESSAGES,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
  GET_ORG_ACCOUNT_WORKLOADS,
  GET_ORG_ACCOUNT_WORKLOADS_SUCCESS,
  GET_ORG_ACCOUNT_WORKLOADS_FAILURE,
  UPDATE_ORG_ACCOUNT_WORKLOAD,
  UPDATE_ORG_ACCOUNT_WORKLOAD_SUCCESS,
  UPDATE_ORG_ACCOUNT_WORKLOAD_FAILURE,
  GET_SCAN_SCHEDULES,
  GET_SCAN_SCHEDULES_SUCCESS,
  GET_SCAN_SCHEDULES_FAILURE,
  UPDATE_SCAN_SCHEDULE_FREQUENCY,
  UPDATE_SCAN_SCHEDULE_FREQUENCY_SUCCESS,
  UPDATE_SCAN_SCHEDULE_FREQUENCY_FAILURE,
  POST_FEATURE_CONFIGURATION,
  POST_FEATURE_CONFIGURATION_SUCCESS,
  POST_FEATURE_CONFIGURATION_FAILURE,
} from "./actionTypes";

export const getOrgAccounts = (orgCode) => {
  console.log("getOrgAccounts action, orgCode:: ", orgCode);
  return {
    type: GET_ORG_ACCOUNTS,
    payload: { orgCode },
  };
};

export const getOrgAccountsSuccess = (orgAccounts) => {
  console.log("getOrgAccountsSuccess action, orgAccounts:: ", orgAccounts);
  return {
    type: GET_ORG_ACCOUNTS_SUCCESS,
    payload: { orgAccounts },
  };
};

export const getOrgAccountsFailure = (error) => {
  console.log("getOrgAccountsFailure action, error:: ", error);
  return {
    type: GET_ORG_ACCOUNTS_FAILURE,
    payload: { error },
  };
};

export const getOrgUsersSuccess = (orgUsers) => {
  console.log("getOrgUsersSuccess action, orgUsers:: ", orgUsers);
  return {
    type: GET_ORG_USERS_SUCCESS,
    payload: { orgUsers },
  };
};

export const getOrgSuccess = (organization) => {
  console.log("getOrgSuccess action, organization :: ", organization);
  return {
    type: GET_ORG_SUCCESS,
    payload: { organization },
  };
};

export const updateOrgAccount = (updateOrgAccountPayload) => {
  return {
    type: UPDATE_ORG_ACCOUNT,
    payload: { updateOrgAccountPayload },
  };
};

export const updateOrgAccountSuccess = () => {
  return {
    type: UPDATE_ORG_ACCOUNT_SUCCESS,
  };
};

export const updateOrgAccountFailure = (error) => {
  return {
    type: UPDATE_ORG_ACCOUNT_FAILURE,
    payload: { error },
  };
};

export const addOrgAccount = (addOrgAccountPayload) => {
  return {
    type: ADD_ORG_ACCOUNT,
    payload: { addOrgAccountPayload },
  };
};

export const addOrgAccountSuccess = () => {
  return {
    type: ADD_ORG_ACCOUNT_SUCCESS,
  };
};

export const addOrgAccountFailure = (error) => {
  return {
    type: ADD_ORG_ACCOUNT_FAILURE,
    payload: { error },
  };
};

export const deleteOrgAccount = (orgCode, orgAccountCode) => {
  return {
    type: DELETE_ORG_ACCOUNT,
    payload: { orgCode,orgAccountCode },
  };
};

export const deleteOrgAccountSuccess = () => {
  return {
    type: DELETE_ORG_ACCOUNT_SUCCESS,
  };
};

export const deleteOrgAccountFailure = (error) => {
  return {
    type: DELETE_ORG_ACCOUNT_FAILURE,
    payload: { error },
  };
};

export const deleteOrgUser = (orgCode, email) => {
  return {
    type: DELETE_ORG_USER,
    payload: { orgCode, email },
  };
};

export const deleteOrgUserSuccess = () => {
  return {
    type: DELETE_ORG_USER_SUCCESS,
  };
};

export const deleteOrgUserFailure = (error) => {
  return {
    type: DELETE_ORG_USER_FAILURE,
    payload: { error },
  };
};

export const clearAllOrgAcctMessages = () => {
  return {
    type: CLEAR_ALL_MESSAGES,
    payload: {},
  };
};

export const clearAllOrgAcctMessagesSuccess = () => {
  return {
    type: CLEAR_ALL_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const clearSuccessOrgAcctMessages = () => {
  return {
    type: CLEAR_SUCCESS_MESSAGES,
    payload: {},
  };
};

export const clearSuccessOrgAcctMessagesSuccess = () => {
  return {
    type: CLEAR_SUCCESS_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const clearFailureOrgAcctMessages = () => {
  return {
    type: CLEAR_FAILURE_MESSAGES,
    payload: {},
  };
};

export const clearFailureOrgAcctMessagesSuccess = () => {
  return {
    type: CLEAR_FAILURE_MESSAGES_SUCCESS,
    payload: {},
  };
};

export const getOrgAccountWorkloads = (accountNumber) => {
  console.log("getOrgAccountWorkloads action, accountNumber:: ", accountNumber);
  return {
    type: GET_ORG_ACCOUNT_WORKLOADS,
    payload: { accountNumber },
  };
};

export const getOrgAccountWorkloadsSuccess = (workloads) => {
  console.log("getOrgAccountWorkloadsSuccess action, workloads:: ", workloads);
  return {
    type: GET_ORG_ACCOUNT_WORKLOADS_SUCCESS,
    payload: { workloads },
  };
};

export const getOrgAccountWorkloadsFailure = (error) => {
  console.log("getOrgAccountWorkloadsFailure action, error:: ", error);
  return {
    type: GET_ORG_ACCOUNT_WORKLOADS_FAILURE,
    payload: error, // Pass the error directly, not wrapped in another object
  };
};

export const updateOrgAccountWorkload = (accountNumber, workloadId, automationRunLimitPerDay) => {
  console.log("updateOrgAccountWorkload action, accountNumber:: ", accountNumber, "workloadId:: ", workloadId, "automationRunLimitPerDay:: ", automationRunLimitPerDay);
  return {
    type: UPDATE_ORG_ACCOUNT_WORKLOAD,
    payload: { accountNumber, workloadId, automationRunLimitPerDay },
  };
};

export const updateOrgAccountWorkloadSuccess = (responseData) => {
  console.log("updateOrgAccountWorkloadSuccess action", responseData);
  return {
    type: UPDATE_ORG_ACCOUNT_WORKLOAD_SUCCESS,
    payload: { responseData },
  };
};

export const updateOrgAccountWorkloadFailure = (error) => {
  console.log("updateOrgAccountWorkloadFailure action, error:: ", error);
  return {
    type: UPDATE_ORG_ACCOUNT_WORKLOAD_FAILURE,
    payload: { error },
  };
};

export const getScanSchedules = (orgCode, accountCode) => {
  console.log("getScanSchedules action, orgCode:: ", orgCode, "accountCode:: ", accountCode);
  return {
    type: GET_SCAN_SCHEDULES,
    payload: { orgCode, accountCode },
  };
};

export const getScanSchedulesSuccess = (schedules) => {
  console.log("getScanSchedulesSuccess action, schedules:: ", schedules);
  return {
    type: GET_SCAN_SCHEDULES_SUCCESS,
    payload: { schedules },
  };
};

export const getScanSchedulesFailure = (error) => {
  console.log("getScanSchedulesFailure action, error:: ", error);
  return {
    type: GET_SCAN_SCHEDULES_FAILURE,
    payload: error,
  };
};

export const updateScanScheduleFrequency = (orgCode, accountCode, scheduleId, frequency, status) => {
  console.log("updateScanScheduleFrequency action, orgCode:: ", orgCode, "accountCode:: ", accountCode, "scheduleId:: ", scheduleId, "frequency:: ", frequency, "status:: ", status);
  return {
    type: UPDATE_SCAN_SCHEDULE_FREQUENCY,
    payload: { orgCode, accountCode, scheduleId, frequency, status },
  };
};

export const updateScanScheduleFrequencySuccess = (responseData) => {
  console.log("updateScanScheduleFrequencySuccess action", responseData);
  return {
    type: UPDATE_SCAN_SCHEDULE_FREQUENCY_SUCCESS,
    payload: { responseData },
  };
};

export const updateScanScheduleFrequencyFailure = (error) => {
  console.log("updateScanScheduleFrequencyFailure action, error:: ", error);
  return {
    type: UPDATE_SCAN_SCHEDULE_FREQUENCY_FAILURE,
    payload: { error },
  };
};

export const postFeatureConfiguration = (featureConfigPayload) => {
  console.log("postFeatureConfiguration action, payload:: ", featureConfigPayload);
  return {
    type: POST_FEATURE_CONFIGURATION,
    payload: { featureConfigPayload },
  };
};

export const postFeatureConfigurationSuccess = (responseData) => {
  console.log("postFeatureConfigurationSuccess action", responseData);
  return {
    type: POST_FEATURE_CONFIGURATION_SUCCESS,
    payload: { responseData },
  };
};

export const postFeatureConfigurationFailure = (error) => {
  console.log("postFeatureConfigurationFailure action, error:: ", error);
  return {
    type: POST_FEATURE_CONFIGURATION_FAILURE,
    payload: { error },
  };
};